import { Component, OnInit } from '@angular/core';
import { TardinessService } from '../../../services/tardiness.service';
import { ChangeIndicator, Direction } from '../../../models/change-indicator';

@Component({
  selector: 'app-tardiness-kpi',
  templateUrl: './tardiness-kpi.component.html',
  styleUrls: ['./tardiness-kpi.component.scss']
})
export class TardinessKpiComponent implements OnInit {
  improved: boolean = false;
  steady: boolean = false;
  worsened: boolean = false;

  changeIndicator: ChangeIndicator;
  constructor(private tardinessService: TardinessService) {
  }

  ngOnInit() {
    this.tardinessService.mostRecentChangeIndicator$.subscribe(changeIndicator => {
      this.changeIndicator = changeIndicator;
      this.initDefaultChangeIndicators();
      switch(changeIndicator.direction) {
        case Direction.up:
          this.worsened = true;
          break;
        case Direction.steady:
          this.steady = true;
          break;
        case Direction.down:
          this.improved = true;
          break;
        case Direction.none:
          break;
        default:
          throw new Error(`no state is set for kpi change indicator ${changeIndicator.direction}`);
      }
    });
  }

  private initDefaultChangeIndicators(): void {
    this.worsened = false;
    this.steady = false;
    this.improved = false;
  }
}
